import React from 'react';
import TypeChip from './TypeChip';
import { TYPE_HEX } from '../data/trackColors';
import Icon from './Icon';

// Normalize sponsor shape to an array of names.
// Accepts: session.sponsors (array of strings OR objects with .name),
// or the legacy session.sponsor (single string).
function normalizeSponsors(session) {
  if (Array.isArray(session.sponsors) && session.sponsors.length) {
    return session.sponsors
      .map((s) => (typeof s === 'string' ? s : s?.name))
      .filter(Boolean);
  }
  if (session.sponsor) return [session.sponsor];
  return [];
}

// `live` / `past` are set on today's agenda: live sessions get a "Happening
// now" badge, finished ones are dimmed so the eye lands on what's next.
export default function SessionCard({ session, live = false, past = false }) {
  const railColor = TYPE_HEX[session.type] || TYPE_HEX.break;
  const hasEntries = Array.isArray(session.entries) && session.entries.length > 0;
  const execOnly = session.audience === 'executive';
  const sponsorNames = normalizeSponsors(session);
  const sponsorLabel = sponsorNames.length
    ? ['Sponsored', ...sponsorNames].join(' · ')
    : null;

  return (
    <div className={`portal-session${execOnly ? ' portal-session-exec' : ''}${live ? ' is-live' : ''}${past ? ' is-past' : ''}`}>
      <div className="portal-session-rail" style={{ background: railColor }} />
      <div className="portal-session-time">
        <div className="portal-session-time-start">{session.time}</div>
        {session.end && <div className="portal-session-time-end">→ {session.end}</div>}
      </div>
      <div className="portal-session-body">
        <TypeChip type={session.type} />
        {live && <span className="portal-session-live-badge">Happening now</span>}
        {execOnly && (
          <span className="portal-session-exec-badge">Executives Only</span>
        )}
        {sponsorLabel && (
          <div className="portal-session-sponsor">{sponsorLabel}</div>
        )}
        <div className="portal-session-title">{session.title}</div>
        {session.speaker && (
          <div className="portal-session-speaker">{session.speaker}</div>
        )}
        {session.loc && (
          <div className="portal-session-loc"><Icon name="map-pin" size={13} /> {session.loc}</div>
        )}
        {hasEntries && (
          <div className="portal-session-entries">
            {session.entries.map((e, i) => (
              <div key={i} className="portal-session-entry">
                <span className="portal-session-entry-company">{e.company || 'TBD'}</span>
                {e.room && <span className="portal-session-entry-room">{e.room}</span>}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
